import React from 'react';
import axios from 'axios';

const PostDataComplex = async (dest, method, action, data) => {
  console.log('PostDataComplex()')

  console.log(`dest: ${dest});`)
  let baseUrl = `/picture-viewer/php/${dest}.php/`;
  console.log(`baseUrl: ${baseUrl});`)

  
  return new Promise((resolve, reject) => {
    
    data.action = action;
    console.log(`action: ${action}`);

    console.log(`data:->`);
    console.log(data);

    const formData = new FormData();

    console.log('====================================');
    Object.keys(data)
      // .filter((k, i) => i >= 100 && i < 300)
      // .forEach(k => console.log(data[k]));
      .forEach(key  => formData.append(key , data[key]) );
    
    formData.append('action', action);

    // console.log('FORMDATA:->');
    // console.log(formData)
    // console.log('====================================');

    axios({
      method: method,
      url: baseUrl,
      data: formData,
      headers: {
        'accept': 'application/json',
        'Accept-Language': 'en-US,en;q=0.8',
        // 'Content-Type': 'application/json',
        'Content-Type': `multipart/form-data;`,
      },
    })
    .then((responseJson) => {
      resolve(responseJson);
    })
    .catch((error) => {
      reject(error)
    });
    
  });

}

export default PostDataComplex;